import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-RealEstateToolkit',
    templateUrl: './RealEstateToolkit.component.html',
    styleUrls: ['./RealEstateToolkit.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RealEstateToolkitComponent implements OnInit {

  status=false;
  constructor() { }

  ngOnInit() {
  }

}
